export default {
    'Menu': 'Menu'
};



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/core/oncanvas/translations/nl.js
// module id = 97
// module chunks = 0